import {
	DiHtml5,
	DiCss3,
	DiJavascript,
	DiReact,
	DiSass,
	DiGit,
	DiGithubBadge,
	DiW3C,
	DiHeroku,
} from 'react-icons/di';
import {
	SiRedux,
	SiTypescript,
	SiTailwindcss,
	SiEthereum,
	SiGraphql,
	SiNetlify,
	SiVercel,
	SiNextdotjs,
	SiNuxtdotjs,
	SiMongodb,
	SiFirebase,
	SiSocketdotio,
	SiVuedotjs
} from 'react-icons/si';

export const technologies = {
	proLanguages: [
		{ name: 'Javascript', icon: <DiJavascript /> },
		{ name: 'Typescript', icon: <SiTypescript /> },
	],
	frontend: [
		{ name: 'React', icon: <DiReact /> },
		{ name: 'Next.js', icon: <SiNextdotjs /> },
		{ name: 'Vue', icon: <SiVuedotjs /> },
		{ name: 'Nuxt.js', icon: <SiNuxtdotjs /> },
		{ name: 'Redux', icon: <SiRedux /> },
		{ name: 'Vuex', icon: <SiNuxtdotjs /> },
		{ name: 'HTML', icon: <DiHtml5 /> },
		{ name: 'CSS', icon: <DiCss3 /> },
		{ name: 'Sass', icon: <DiSass /> },
		{ name: 'TailwindCss', icon: <SiTailwindcss /> },
	],
	webB: [
		{ name: 'Ether.js', icon: <SiEthereum /> },
		{ name: 'Web3.js', icon: <DiW3C /> },
	],
	apisData: [
		{ name: 'Firebase', icon: <SiFirebase /> },
		{ name: 'MongoDB', icon: <SiMongodb /> },
		{ name: 'GraphQL', icon: <SiGraphql /> },
		{ name: 'WebSockets', icon: <SiSocketdotio /> },
	],
	toolsPlatforms: [
		{ name: 'Git', icon: <DiGit /> },
		{ name: 'Github', icon: <DiGithubBadge /> },
		{ name: 'Heroku', icon: <DiHeroku /> },
		{ name: 'Vercel', icon: <SiVercel /> },
		{ name: 'Netlify', icon: <SiNetlify /> },
	],
};
